import { Routes } from '@angular/router';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { HomeComponent } from '../../home/home.component';
import { GardenComponent } from '../../garden/garden.component';
import { UserProfileComponent } from '../../user-profile/user-profile.component';
import { AgendaComponent } from '../../agenda/agenda.component';
import { AgendaTaskComponent } from '../../agenda/agenda-task/agenda-task.component';
import { AgendaArchivesComponent } from '../../agenda/agenda-archives/agenda-archives.component';
import { UserSeedsComponent } from '../../garden/user-seeds/user-seeds.component';
import { NavigationGuard } from '../guards/navigation.guard';
import { GardenOverviewComponent } from '../../garden/garden-overview/garden-overview.component';
import { CalendarComponent } from '../../calendar/calendar.component';
import { LunarDetailComponent } from '../../lunar/lunar-detail.component';
import { WeatherDetailComponent } from '../../weather/weather-detail.component';

export const mainLayoutRoutes: Routes = [
  {
    path: '', // Default route for main layout
    component: MainLayoutComponent,
    children: [
      {
        path: 'home',
        component: HomeComponent,
        canActivate: [NavigationGuard],
      },
      {
        path: 'calendar',
        component: CalendarComponent,
        canActivate: [NavigationGuard],
      },
      {
        path: 'lunar',
        component: LunarDetailComponent,
        canActivate: [NavigationGuard],
      },
      {
        path: 'weather',
        component: WeatherDetailComponent,
        canActivate: [NavigationGuard],
      },
      {
        path: 'agenda', // Parent path for agenda
        component: AgendaComponent,
        children: [
          { path: '', redirectTo: 'tasks', pathMatch: 'full' }, // Default child route is 'tasks'
          { path: 'tasks', component: AgendaTaskComponent, canActivate: [NavigationGuard] },   // Task tab
          { path: 'archives', component: AgendaArchivesComponent, canActivate: [NavigationGuard] }, // Archive tab
        ],
        canActivate: [NavigationGuard],
      },
      {
        path: 'garden', component: GardenComponent,
        children: [
          { path: '', redirectTo: 'list', pathMatch: 'full' }, // Default child route is 'tasks'
          { path: 'list', component: GardenOverviewComponent, canActivate: [NavigationGuard] },   // « Mon Potager » — vue zones › planches › cultures (#202)
          { path: 'seeds', component: UserSeedsComponent, canActivate: [NavigationGuard] }, // Archive tab
        ],
        canActivate: [NavigationGuard],
      },
      {
        path: 'profile',
        component: UserProfileComponent,
        canActivate: [NavigationGuard]
      },
      { path: '', redirectTo: 'home', pathMatch: 'full' },
    ],
  }
];
